<template>
  <div class="content padding20">
    <div class="font12 ">
      <el-button
        class="create_btn"
        @click="templateCreate"
      >
        创建运费模版
      </el-button>
    </div>
    <div class="config_list flex">
      <div
        v-for="item in deliveryList"
        :key="item.id"
        class="template_list "
      >
        <div
          v-if="item.supply_cnt"
          class="relevance font14 "
        >
          关联{{ item.supply_cnt }}个供应
        </div>
        <div class="template_name font16 item">
          <span>{{ item.name }}</span>
        </div>
        <!-- <div class="template_type font14 item">
          <span>{{item.name}}</span>
        </div> -->
        <div class="template_unit font14 item">
          <span>单位：元/{{ item.unit | getUnitName }}</span>
        </div>
        <div class="template_delivery font14 item flex">
          <span>配送：</span>
          <div class="delivery">
            {{ item.desp }}
          </div>
        </div>
        <div class="viewDetail font14 item">
          <el-button
            type="text"
            @click="deliveryDialog=true"
          >
            查看全部
          </el-button>
        </div>
        <div class="font12  flex edit">
          <el-button
            class="bottom_btn"
            @click="templateEdit"
          >
            编辑
          </el-button>
        </div>
      </div>
      <div
        v-show="deliveryDialog"
        class="delivery_dialog dialog1"
      >
        <div class="top_content  font16 flex">
          <div class="title">
            可配送区域
          </div>
          <div
            class="close"
            @click="close"
          >
            <img
              src="http://img.yimutian.com/misc/5d131015885b9303cb18272615db7aed.png"
              alt
            >
          </div>
        </div>
        <div class="middle_content  content1">
          <div class="middle_top flex border height32 font14 paddingline20">
            <div class="middle_title">
              省份
            </div>
            <div class="middle_value">
              运费（元）
            </div>
          </div>
          <div
            v-for="item in 10"
            :key="item"
            class="middle_top flex items font14 paddingline20"
          >
            <div class="middle_title">
              陕西省
            </div>
            <div class="middle_value">
              6
            </div>
          </div>
        </div>
        <div class="bottom_content flex">
          <div>
            <el-button class="confim btn">
              确定
            </el-button>
          </div>
          <div>
            <el-button
              class="cancel btn"
              @click="cancel"
            >
              取消
            </el-button>
          </div>
        </div>
      </div>
      <div
        v-show="templateDialog"
        class="delivery_dialog dialog2"
      >
        <div class="top_content  font16 flex">
          <div class="title">
            创建运费模板
          </div>
          <div
            class="close"
            @click="close"
          >
            <img
              src="http://img.yimutian.com/misc/5d131015885b9303cb18272615db7aed.png"
              alt
            >
          </div>
        </div>
        <div class="middle_content  content2">
          <div class="middle_top flex height32 font14">
            <div class="template_name">
              模版名称
            </div>
            <div class="width300">
              <!-- <input type="text" placeholder="请输入模版名称" class="input"/> -->
              <el-input
                v-model="templateName"
                type="text"
                placeholder="请输入模版名称"
                class="input"
                size="small"
              />
            </div>
          </div>
          <div class="middle_top flex height32 font14 paddingtop20">
            <div class="template_name">
              商品单位
            </div>
            <div class="width300">
              <!-- <select name="" id="" class="input select">
                <option value="">请选择商品单位</option>
                <option value="">元/件</option>
                <option value="">元/箱</option>
                <option value="">元/斤</option>
              </select>-->
              <el-select
                v-model="templateUnit"
                placeholder="请选择商品单位"
                size="small"
                class="select"
              >
                <el-option
                  v-for="item in unitList"
                  :key="item.id"
                  :label="'元/'+item.name"
                  :value="item.id"
                />
              </el-select>
            </div>
          </div>
          <div class="option_content flex">
            <div class="option_left font14">
              已接单的省份
            </div>
            <div class="option_right">
              <div class="option_right_top flex border">
                <div class="check_content">
                  <el-checkbox
                    v-model="unifyChecked"
                    :indeterminate="isIndeterminate"
                    @change="handleCheckAllChange"
                  >
                    全国
                  </el-checkbox>
                </div>
                <div class="right_option_top_content flex">
                  <div class="font14 option_item">
                    运费
                  </div>
                  <el-button
                    type="text"
                    class="set option_item"
                    @click="setUnifyPrice"
                  >
                    批量设置
                  </el-button>
                  <el-input
                    v-if="setAllUnify"
                    v-model="unifyPrice"
                    type="number"
                    class="option_item set_input"
                    placeholder="0.00"
                    size="mini"
                    @input="editUnifyPrice"
                  />
                </div>
              </div>
              <div
                class="option_right_bottom"
                style="padding-top:6px"
              >
                <el-checkbox-group
                  v-model="checkedCities"
                  @change="handleCheckedCitiesChange"
                >
                  <div
                    v-for="(city,index) in cities"
                    :key="index"
                    class="option_right_top flex "
                  >
                    <div class="check_content">
                      <el-checkbox
                        :key="city.name"
                        v-model="city.checked"
                        :label="city.name"
                        :checked="city.checked"
                        @change="changeChecked(index)"
                      >
                        {{ city.name }}
                      </el-checkbox>
                    </div>
                    <div class="right_option_top_content flex">
                      <el-input
                        v-if="city.checked==true"
                        v-model="city.price"
                        type="number"
                        class="option_item long_input"
                        placeholder="0.00"
                        size="mini"
                        @input="setAllUnify = false"
                      />
                    </div>
                  </div>
                </el-checkbox-group>
              </div>
            </div>
          </div>
        </div>
        <div class="bottom_content flex">
          <div>
            <el-button
              class="confim btn"
              @click="publishLogisticTpl"
            >
              确定
            </el-button>
          </div>
          <div>
            <el-button
              class="cancel btn"
              @click="cancel"
            >
              取消
            </el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Message } from 'element-ui'
import { delivery } from '@/api'
export default {
  data() {
    return {
      options: [
        {
          value: '选项1',
          label: '元/斤'
        },
        {
          value: '选项2',
          label: '元/袋'
        },
        {
          value: '选项3',
          label: '元/箱'
        },
        {
          value: '选项4',
          label: '元/瓶'
        },
        {
          value: '选项5',
          label: '元/桶'
        }
      ],
      templateUnit: '',
      deliveryDialog: false,
      templateDialog: false,
      templateName: '',
      unifyPrice: '',
      unifyChecked: '',
      itemPrice: '',
      checkAll: false,
      checkedCities: [],
      cities: [],
      isIndeterminate: true,
      deliveryList: [],
      unitList: [],
      setAllUnify: false // 批量设置
    }
  },
  mounted() {
    this.getdelivery()
    this.getunitsList()
    this.getSublist()
  },
  methods: {
    close() {
      this.deliveryDialog = false
      this.templateDialog = false
    },
    templateEdit() {
      this.templateDialog = true
    },
    templateCreate() {
      this.templateDialog = true
    },
    setUnifyPrice() {
      if (this.checkedCities.length === 0) {
        return
      }
      if (!this.setAllUnify) {
        this.unifyPrice = ''
      }
      this.setAllUnify = true
    },
    editUnifyPrice(value) {
      this.cities.map((v) => {
        if (v.checked) {
          v.price = Number(value)
        }
      })
    },
    handleCheckAllChange(val) {
      if (val) {
        this.checkedCities = this.cities.map((v) => {
          v.checked = true
          return v.name
        })
      } else {
        this.checkedCities = []
        this.setAllUnify = false
        this.checkedCities = this.cities.map((v) => {
          v.checked = false
          v.price = ''
          return []
        })
      }
      this.isIndeterminate = !this.isIndeterminate
    },
    handleCheckedCitiesChange(value) {
      let checkedCount = value.length
      this.unifyChecked = checkedCount === this.cities.length
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.cities.length
    },
    getdelivery() {
      delivery.listLogisticTpl({}).then(({ data }) => {
        if (data.status === 0) {
          this.deliveryList = data.header.concat(data.data)
        }
      })
    },
    getunitsList() {
      delivery.getunitsList().then(({ data }) => {
        if (data.status === 0) {
          this.unitList = data.result
        }
      })
    },
    getSublist() {
      delivery.getSublist().then(({ data }) => {
        if (data.status === 0) {
          let cities = data.data
          cities.map((v) => {
            v.price = ''
            v.checked = false
          })
          this.cities = cities
        }
      })
    },
    changeChecked(index) {
      this.cities[index].checked = !this.cities[index].checke      
    },
    cancel() {
      this.deliveryDialog = false
      this.templateDialog = false
    },
    picksItem(oriArr, arr) {
      let newArr = []
      try {
        oriArr.forEach((v) => {
          if (!v.price && v.checked) {
            this.$message.error('请设置价格')
            throw new Error()
          }
          v.checked && newArr.push(arr.reduce((item, val) => (val in v && (item[val] = Number(v[val])), item), {}))
        })
        return newArr
      } catch (error) {}
    },
    publishLogisticTpl() {
      let postage = this.picksItem(this.cities, ['id', 'price'])
      let param = {
        name: this.templateName,
        unit: this.templateUnit,
        postage: postage
      }
      delivery.publishLogisticTpl(param).then(({ data }) => {
        if (data.status === 0) {
          // console.log(data)
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
* {
  font-weight: 0;
}
.content {
  background: #ffffff;
  .config_list {
    padding-top: 20px;
    flex-wrap: wrap;
    position: relative;
    .dialog1 {
      width: 434px;
      height: 592px;
      margin-left: -217px;
      margin-top: -296px;
    }
    .dialog2 {
      width: 596px;
      height: 568px;
      margin-left: -298px;
      margin-top: -284px;
    }
    .delivery_dialog {
      position: fixed;
      top: 50%;
      left: 50%;
      background: #ffffff;
      box-shadow: 0 3px 9px 0 rgba(2, 64, 52, 0.14);
      .top_content {
        width: 100%;
        height: 50px;
        background: #666666;
        border-radius: 2px 2px 0 0;
        padding: 14px 20px;
        color: #ffffff;
        box-sizing: border-box;
      }
      .middle_content {
        margin: 30px 30px 20px 30px;
        .middle_top {
          align-items: center;
          // justify-content: center;
        }
        .paddingline20 {
          padding: 0 20px;
        }
        .paddingtop20 {
          padding: 20px 0;
        }
        .middle_title {
          flex: 1;
        }
        .middle_value {
          width: 80px;
          text-align: center;
        }
        .template_name {
          width: 56px;
          padding-right: 20px;
        }
        .input {
          width: 100%;
          // height: 30px;
          // border: 1px solid #B7B7B7;
          // border-radius: 2px;
          // padding-left: 10px;
          font-size: 14px;
          color: #333333;
          box-sizing: border-box;
        }
        .select {
          background: #ffffff;
          width: 100%;
        }
        .border {
          border-bottom: 1px solid #b7b7b7;
        }
        .height32 {
          height: 32px;
        }
        .items {
          padding-top: 15px;
        }
        .width300 {
          width: 300px;
        }
      }
      .content1 {
        width: 374px;
        height: 433px;
        border: 1px solid #b7b7b7;
        border-radius: 2px;
      }
      .content2 {
      }
      .option_content {
        width: 536px;
        height: 298px;
        border: 1px solid #b7b7b7;
        .option_left {
          background: #f6f6f6;
          border-right: 1px solid #b7b7b7;
          border-radius: 2px 0 0 2px;
          font-family: PingFangSC-Regular;
          color: #333333;
          padding: 5px 20px;
        }
        .option_right {
          padding: 6px 0px 20px 0px;
          height: 298px;
          box-sizing: border-box;
          flex: 1;
          .option_right_top {
            padding: 0px 10px 4px 10px;
            align-items: center;
            border-radius: 0 2px 0 0;
            .check_content {
              flex: 1;
            }
          }
          .option_right_bottom{
            height: 240px;
            overflow: scroll;
          }
          .checklist {
            flex-direction: column;
          }
          .right_option_top_content {
            width: 180px;
            align-items: center;
            .option_item {
              padding-left: 10px;
            }
            .set_input {
              width: 64px;
            }
            .long_input{
              width: 104px;
            }
          }
        }
      }
      .bottom_content {
        justify-content: center;
        align-items: center;
        .btn {
          width: 64px;
          height: 30px;
          border-radius: 2px;
        }
        .confim {
          border: 1px solid #00ac8b;
          color: #00ac8b;
          margin-right: 20px;
        }
        .cancel {
          color: #666666;
          border: 1px solid #666666;
        }
      }
      .title {
        flex: 1;
      }
      .close {
        float: right;
        img {
          width: 15.6px;
          height: 15.6px;
        }
      }
    }
  }
  .template_list {
    position: relative;
    background: #f6f6f6;
    border-radius: 2px;
    padding: 20px;
    width: 300px;
    height: 300px;
    margin-right: 10px;
    margin-top: 10px;
    .unit {
      width: 120px;
      height: 30px;
    }
    .relevance {
      position: absolute;
      top: 0;
      right: 0;
      background: #666666;
      border-radius: 0 2px 0 2px;
      color: #ffffff;
      height: 30px;
      width: 100px;
      line-height: 30px;
      text-align: center;
    }
  }
  .item {
    padding-bottom: 10px;
  }
  .template_delivery {
    flex: 1;
    .delivery {
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 3;
      overflow: hidden;
      flex: 1;
    }
  }
  .viewDetail {
    text-align: right;
  }
  .edit {
    flex: 1;
    justify-content: center;
    align-items: center;
    padding-top: 20px;
  }
  .bottom_btn {
    width: 86px;
    height: 30px;
    text-align: center;
    color: #00ac8b;
  }
}
.el-button {
  padding: 0;
  margin: 0;
}
.font12 {
  font-size: 12px;
}
.font16 {
  font-size: 16px;
}
.font14 {
  font-size: 14px;
}
.create_btn {
  height: 0.3rem;
  width: 0.96rem;
  color: #333333;
  border-radius: 2px;
}
.el-checkbox__inner:hover{
  border: 1px solid #00ac8b;
}
</style>
